import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_PROJECT_MEASUREMENT_POINTS',
  name: 'Workspace Project Measurement Points',
  type: 'PROJECT',
  description: '',
  modules: [],
  fields: [
    { key: 'files', title: 'Files' },
    { key: 'type', title: 'Measurement point type' },
    { key: 'name', title: 'Name' },
    { key: 'measurementDate', title: 'Measurement Date' },
    { key: 'value', title: 'Value' },
    { key: 'currentChange', title: 'Current Change' },
  ],
  related: ['WORKSPACE_PROJECT_METRIC', 'WORKSPACE_PROJECT_UTILITY_UNIT_OF_MEASUREMENT'],
  actions: ['READ', 'CREATE', 'UPDATE', 'UPLOAD', 'DESTROY'],
}

export default scope
